import { Query } from 'ducks/types/query-types';

export const getBatchesPostData = (data?: Query) => {
  return {
    start_date: data?.start_date || '',
    finish_date: data?.finish_date || '',
    created_by: data?.created_by || '',
    max_rows: data?.max_rows || 100,
    filter: data?.filter || '',
    include_archived: data?.include_archived || false,
    parameter_name: data?.parameter_name || '',
    parameter_value: data?.parameter_value || '',
  };
};
